import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { ClipLoader } from "react-spinners";

export default function Loading() {
  const [isLoading, setLoading] = useState(false);
  const data = useSelector(state => state.loading.data);

  useEffect(() => {
    if (data.isLoading !== null) {
      setLoading(data.isLoading);
    }
  }, [data.isLoading]);

  const renderLoadingComponent = (load) => {
    return load === true ? (
      <div >
        <div style={{ position: 'absolute', top: '0', left: ' 0', right: '0', bottom: '-150px', backgroundColor: 'rgba(255, 255, 255,0.5)' }}>
          <div style={{ position: 'absolute', top: '49%', left: '49%' }}>
            <ClipLoader loading={data.loading} size={50} color="#999" />
          </div>
        </div>
      </div>
    ) : (<div></div>)
  }

  return (
    <React.Fragment>
      {renderLoadingComponent(isLoading)}
    </React.Fragment>
  );
}
